import * as React from 'react';
import { useLocation, Link } from 'react-router-dom';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import PeopleRoundedIcon from '@mui/icons-material/PeopleRounded';
import FilePresentRoundedIcon from '@mui/icons-material/FilePresentRounded';
import BusinessCenterRoundedIcon from '@mui/icons-material/BusinessCenterRounded';
import VpnKeyIcon from '@mui/icons-material/VpnKey';

const mainListItems = [
  { text: 'Exportações', icon: <FilePresentRoundedIcon />, path: '/' },
  { text: 'Usuários', icon: <PeopleRoundedIcon />, path: '/usuarios' },
  { text: 'Empresas', icon: <BusinessCenterRoundedIcon />, path: '/empresas' },
  { text: 'Login Betha', icon: <VpnKeyIcon />, path: '/dados' },
];

export default function MenuContent() {
  const location = useLocation();
  const pathname = `/${location.pathname.split('/')[1]}`;

  return (
    <Stack sx={{ flexGrow: 1, p: 1, justifyContent: 'space-between' }}>
      <List dense>
        {mainListItems.map((item, index) => (
          <ListItem key={index} disablePadding sx={{ borderRadius: '4px', display: 'block' }}>
            <ListItemButton
              sx={{ borderRadius: '4px' }}
              selected={pathname === item.path}
              component={Link}
              to={item.path}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Stack>
  );
}
